// @ts-nocheck

import React, { useState, useEffect } from 'react';
import { fetchMonthly } from '../../../utils/fetch';
import Layout from '../../../components/Layout';
import Od from '../../../containers/Od';
import { genYYYYMM } from '../../../utils';
import TemplateLayout from '../../../components/LayoutViz';
import Loading from '../../../components/Loading';
import {
    getSystemList,
    getConfig,
    getAvailableAnalysis,
    getSystemListWithConfigAndGeo,
} from '../../../utils/getPageProps';
import { OD_PAGE, YEARLY_REPORT } from '../../../utils/static';
import { ShareProps } from '../../../../types/share';
import {getDynamicPageLocalePath} from '../../../utils/staticPath';

type Props = {
    yyyymm: ShareProps['yyyymm'],
    system: ShareProps['system']
    year: ShareProps['year'],
    month: ShareProps['month'],
    locale: ShareProps['locale'],
    config: ShareProps['config'],
    page: ShareProps['page'],
    systemList: ShareProps['systemList'],
    availableAnalysis: ShareProps['availableAnalysis'],
    seo: ShareProps['seo'],
}

const OdTemplate = ({
    yyyymm, system, year, month, locale, config, page, systemList, availableAnalysis, seo,
}: Props) => {
    const [stationList, setStationList] = useState(null);
    const [geo, setGeo] = useState(null);
    const [hourlyDeal, setHourlyDeal] = useState(null);
    const [odCount, setOdCount] = useState(null);
    const [stationWdayDeal, setWdayBorrow] = useState(null);
    const [availableTime, setAvailableTime] = useState(null);
    const [stationHourDeal, setStationHourDeal] = useState(null);
    const [stationDeal, setStationDeal] = useState(null);
    const [odMovingTime, setOdMovingTime] = useState(null);
    const [dateDeal, setDateDeal] = useState(null);
    const [monthDeal, setMonthDeal] = useState(null);
    const [isMountLoaded, setIsMountLoaded] = useState(false);

    // Mount action
    useEffect(() => {
        Promise.all([
            fetchMonthly({ yyyymm, system, filename: 'hourly_deal.json' }),
            fetchMonthly({ yyyymm, system, filename: 'od_count.json' }),
            fetchMonthly({ yyyymm, system, filename: 'station_wday_deal.json' }),
            fetchMonthly({ yyyymm, system, filename: 'available_time.json' }),
            fetchMonthly({ yyyymm, system, filename: 'station_deal.json' }),
            fetchMonthly({ yyyymm, system, filename: 'od_moving_time.json' }),
            fetchMonthly({ yyyymm, system, filename: 'date_deal.json' }),
            fetchMonthly({ yyyymm, system, filename: 'station_hour_deal.json' }),
            fetchMonthly({ yyyymm, system, filename: 'geo.json' }),
        ]).then((results) => {
            const [
                _hourlyDeal,
                _odCount,
                _stationWdayDeal,
                _availableTime,
                _stationDeal,
                _odMovingTime,
                _dateDeal,
                _stationHourDeal,
                _geo,
            ] = results;
            setHourlyDeal(_hourlyDeal);
            setOdCount(_odCount);
            setWdayBorrow(_stationWdayDeal);
            setAvailableTime(_availableTime);
            setStationDeal(_stationDeal);
            setOdMovingTime(_odMovingTime);
            setGeo(_geo);
            setStationList(Object.keys(_geo));

            const _monthDeal = {};
            for (const y in _dateDeal) {
                _monthDeal[y] = {};
                for (const m in _dateDeal[y]) {
                    let trans = 0;
                    for (const day in _dateDeal[y][m]) trans += _dateDeal[y][m][day];
                    _monthDeal[y][m] = trans;
                }
            }
            setMonthDeal(_monthDeal);
            setDateDeal(_dateDeal);
            setStationHourDeal(_stationHourDeal);
            setIsMountLoaded(true);
        });
    }, []);

    return (
        <Layout seo={seo} locale={locale}>
            <TemplateLayout
                page={page}
                system={system}
                locale={locale}
                config={config}
                year={year}
                month={month}
                systemList={systemList}
                availableAnalysis={availableAnalysis}
            >
                {isMountLoaded ? (
                    <Od
                        availableTime={availableTime}
                        stationWdayDeal={stationWdayDeal}
                        config={config}
                        geo={geo}
                        stationHourDeal={stationHourDeal}
                        hourlyDeal={hourlyDeal}
                        stationlist={stationList}
                        odCount={odCount}
                        currentStation={null}
                        stationDeal={stationDeal}
                        odMovingTime={odMovingTime}
                        sortedDateRange={config.dateRange}
                        monthDeal={monthDeal}
                    />
                ) : <Loading />}
            </TemplateLayout>
        </Layout>
    );
};
export async function getStaticProps(context) {
    const { locale } = context;
    const { date, system } = context.params;
    const year = date[0];
    const month = date[1] || null;
    const yyyymm = genYYYYMM(year, month);

    const config = getConfig({
        system, year, month, locale, page: OD_PAGE,
    });
    return {
        props: {
            yyyymm,
            systemList: getSystemList(locale),
            locale,
            system,
            year,
            month: month || null,
            availableAnalysis: getAvailableAnalysis(system),
            page: OD_PAGE,
            config,
            seo: {
                page: OD_PAGE,
                year,
                month,
                system,
                isYearlyReport: config.reportType === YEARLY_REPORT
            }
        },
    };
}

export async function getStaticPaths() {
    let paths = [];

    getSystemListWithConfigAndGeo().forEach(({
        system, year, month, reportType,
    }) => {
        if (reportType === YEARLY_REPORT) {
            paths = [
                ...paths,
                ...getDynamicPageLocalePath(
                    {
                        system,
                        date: [`${year}`],
                    }
                )
            ];
        } else {
            paths = [
                ...paths,
                ...getDynamicPageLocalePath(
                    {
                        system,
                        date: [`${year}`, `${month}`],
                    }
                )
            ];
        }
    });
    return {
        paths,
        fallback: false, // See the "fallback" section below
    };
}

export default OdTemplate;
